const PRIMARY_LEGEND_COLOR = '#7663EB';

export const AC_OVERVIEW_PROGRESS_COLORS = {
  acmevUsed: '#E8507E',
  acrtAchieved: '#48C80C',
  acohUsed: '#FF8D28',
  primary: PRIMARY_LEGEND_COLOR
} as const;

export interface ACOverviewProgressMetrics {
  remainingAcmevPercent: number;
  usedAcmevPercent: number;
  acmevRemainingAmount: number;
  acmevUsedAmount: number;
  achievedAcrtPercent: number;
  projectedAcrtPercent: number;
  acrtAchievedAmount: number;
  usedAcohPercent: number;
  remainingAcohPercent: number;
  acohUsedAmount: number;
}

export const getACOverviewProgressMetrics = (ac: Record<string, any> = {}): ACOverviewProgressMetrics => {
  const acmevRemaining = ac.acmev ?? 0;
  const acmevUsed = ac.acmev_used ?? 0;
  const acmevTotal = acmevRemaining + acmevUsed;
  const remainingAcmevPercent =
    acmevTotal > 0 ? Math.round((acmevRemaining / acmevTotal) * 100) : acmevRemaining > 0 ? 100 : 0;
  const usedAcmevPercent = acmevTotal > 0 ? Math.round((acmevUsed / acmevTotal) * 100) : 0;

  const acrtTotal = ac.acrt ?? 0;
  const acrtAchieved = ac.acrt_achieved ?? 0;
  const achievedAcrtPercent = acrtTotal > 0 ? Math.round((acrtAchieved / acrtTotal) * 100) : 0;
  const projectedAcrtPercent = acrtTotal > 0 ? Math.max(0, 100 - achievedAcrtPercent) : 100;

  const acohTotal = ac.acoh ?? 0;
  const acohUsed = ac.acoh_used ?? 0;
  const usedAcohPercent = acohTotal > 0 ? Math.round((acohUsed / acohTotal) * 100) : 0;
  const remainingAcohPercent = acohTotal > 0 ? Math.max(0, 100 - usedAcohPercent) : 100;

  return {
    remainingAcmevPercent,
    usedAcmevPercent,
    acmevRemainingAmount: acmevRemaining,
    acmevUsedAmount: acmevUsed,
    achievedAcrtPercent,
    projectedAcrtPercent,
    acrtAchievedAmount: acrtAchieved,
    usedAcohPercent,
    remainingAcohPercent,
    acohUsedAmount: acohUsed
  };
};
